"use client";

import type { AudioSample, OmniboxSlidesBlock } from "@mw/shared/payload-types";

import { useMemo } from "react";

import { MusicPlayer, type MusicPlayerItem } from "@ui/components/core/MusicPlayer";
import { MusicColorScheme } from "@ui/components/routes/music/colorScheme";

type CMSMusicSongs = NonNullable<NonNullable<OmniboxSlidesBlock["items"][number]["demoConfig"]>["music"]>["songs"];

export interface MusicDemoProps {
  songs: CMSMusicSongs;
  trackingSource?: string;
}

function toMusicPlayerItem(sample: AudioSample): MusicPlayerItem | null {
  if (!sample.audio) return null;
  return {
    title: sample.title ?? "",
    styles: sample.styleTags?.map(s => s.tag).filter((tag): tag is string => !!tag) ?? [],
    audio: sample.audio,
    colorScheme: sample.orbColor ? MusicColorScheme[sample.orbColor] : undefined,
  };
}

export function MusicDemo({ songs, trackingSource }: MusicDemoProps) {
  const items = useMemo(() => {
    if (!songs) return [];
    return songs.flatMap((song: NonNullable<CMSMusicSongs>[number]) => {
      if (typeof song.audioSample !== "object" || !song.audioSample) return [];
      const item = toMusicPlayerItem(song.audioSample);
      return item ? [item] : [];
    });
  }, [songs]);

  return (
    <div className='tw-h-[80%] md:tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center'>
      <div className='tw-h-full tw-w-auto tw-aspect-[3/4] tw-max-w-full'>
        <MusicPlayer items={items} trackingSource={trackingSource} />
      </div>
    </div>
  );
}

export default MusicDemo;
